export enum SettingsSection {
  PersonalDetails = "personal-details",
  Support = "support",
  Users = "users",
  MyAccess = "my-access",
  Display = "display",
  Notifications = "notifications",
  LoginHistory = "login-history",
}
